module.exports = __webpack_public_path__ + "static/media/panricoWhite@2x.59e770f2.png";